module.exports = __webpack_public_path__ + "static/img/22.c889a745.png";